import { OfferSource } from '@cds';
import { MessageEnvelope } from '@cds/push';
import { exhaustiveCheckGuard } from '@frontend/sports/common/core/utils/extended-types';
import { Store } from '@ngrx/store';

import PickSubscriptionActions from '../pick-subscription-actions';

export class SubscriptionCallBacksPool {
    private subscriptionPool: { [key: string]: (msg: MessageEnvelope) => void } = {};

    constructor(protected store: Store) {}

    getSubscriptionCallback(subscriptionType: OfferSource, keys: string[]): (msg: MessageEnvelope) => void {
        const callbacks: ((msg: MessageEnvelope) => void)[] = [];

        for (const k of keys) {
            const existingCallback = this.subscriptionPool[k];
            if (existingCallback) {
                callbacks.push(existingCallback);
                continue;
            }

            let callback: (msg: MessageEnvelope) => void;
            switch (subscriptionType) {
                case OfferSource.V1:
                    callback = (msg: MessageEnvelope) => this.eventUpdated(msg);
                    break;
                case OfferSource.V2:
                    callback = (msg: MessageEnvelope) => this.fixtureUpdated(msg);
                    break;
                case OfferSource.BetBuilder:
                    callback = (msg: MessageEnvelope) => this.betBuilderGroupUpdated(msg);
                    break;
                default:
                    exhaustiveCheckGuard(subscriptionType);
                    throw new Error('Only offer source V1, V2, and BetBuilder are supported');
            }

            this.subscriptionPool[k] = callback;
            callbacks.push(callback);
        }

        if (callbacks.length === 0) {
            throw new Error('Wrong keys found?');
        }

        return (msg: MessageEnvelope) => {
            for (const callback of callbacks) {
                callback(msg);
            }
        };
    }

    clearSubscriptionPool(): void {
        this.subscriptionPool = {};
    }

    protected eventUpdated = (message: MessageEnvelope) => {
        this.store.dispatch(PickSubscriptionActions.eventUpdated({ message }));
    };

    protected fixtureUpdated = (message: MessageEnvelope) => {
        this.store.dispatch(PickSubscriptionActions.fixtureUpdated({ message }));
    };

    protected betBuilderGroupUpdated = (message: MessageEnvelope) => {
        this.store.dispatch(PickSubscriptionActions.betBuilderGroupUpdated({ message }));
    };

    hasSubscription(key: string): boolean {
        return !!this.subscriptionPool[key];
    }
}
